
import createBrowserHistory from 'history/createBrowserHistory'
import { Route, BrowserRouter as Router } from 'react-router-dom'
import SmartPayRouter from './routes';

let customHistory = createBrowserHistory();

const AppRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} component={Component} />
  )
}

function App() {
  return (
    <Router history={customHistory} >
      <SmartPayRouter AppRoute={AppRoute} />
    </Router>
  );
}

export default App;
